/** @format */

import React from 'react';
import Moment from 'moment';

function Booking(props) {
	const booking = props.booking;

	return (
		<div className='booking'>
			<h1>{booking.title}</h1>
			{booking.travelOut !== null && (
				<>
					<h2>{Moment(booking.travelOut.departure).format('dddd DD.MM.YYYY')}</h2>
					<ul>
						<li>
							<label>
								{booking.travelOut.stopIdDepartureName} - {booking.travelOut.stopIdArrivalName}
							</label>
							<span>
								{' '}
								{Moment(booking.travelOut.departure).format('HH:mm')} -{' '}
								{Moment(booking.travelOut.arrival).format('HH:mm')}{' '}
							</span>
						</li>
					</ul>
				</>
			)}
			<hr />
		</div>
	);
}

export default Booking;
